(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ukfc-workspace"] && !Shopify.designMode) return;
  try {
    if (!window.ukfcWorkspaceBound) {
    window.ukfcWorkspaceBound = true;
    const storageKey = () => {
      const customerId = document.querySelector('[data-ukfc-customer-id]')?.dataset.ukfcCustomerId;
      return customerId ? `ukfc_saved_quote_list_v2_customer_${customerId}` : 'ukfc_saved_quote_list_v2_guest';
    };
    let signedIn = false;
    let changedBeforeAccountLoaded = false;
    let reflectingAccountLoad = false;
    let accountWorkspace = null;
    let pendingAccountSave = null;
    const newId = () => window.crypto?.randomUUID?.() || 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
      const random = Math.floor(Math.random() * 16);
      return (character === 'x' ? random : (random & 0x3) | 0x8).toString(16);
    });
    const normaliseItem = (item) => ({
      variantId: String(item.variantId || item.key || item.url || item.title || ''),
      productHandle: String(item.productHandle || '').trim() || String(item.url || '').split('/products/')[1]?.split(/[?#/]/)[0] || 'saved-product',
      title: String(item.title || 'Saved product').slice(0, 300),
      variantTitle: String(item.variantTitle || '').slice(0, 300),
      sku: String(item.sku || '').slice(0, 120),
      isPoa: item.isPoa === true,
      url: String(item.url || window.location.origin),
      quantity: Math.max(1, Math.min(9999, Number.parseInt(item.quantity, 10) || 1))
    });
    const readList = () => {
      try {
        const stored = JSON.parse(localStorage.getItem(storageKey()) || '[]');
        return Array.isArray(stored) ? stored.filter(Boolean).map(normaliseItem) : [];
      } catch (error) { return []; }
    };
    const writeList = (items) => localStorage.setItem(storageKey(), JSON.stringify(items.map(normaliseItem)));
    const browserItems = (items) => items.map((item) => ({ ...item, key: item.variantId }));
    const makeList = (items = []) => {
      const now = new Date().toISOString();
      return { id: newId(), name: 'Saved list', createdAt: now, updatedAt: now, items };
    };
    const mergeItems = (remoteItems, localItems) => {
      const merged = new Map(remoteItems.map((item) => [item.variantId, item]));
      localItems.forEach((item) => {
        const normalised = normaliseItem(item);
        const previous = merged.get(normalised.variantId);
        merged.set(normalised.variantId, previous ? { ...previous, quantity: Math.min(9999, previous.quantity + normalised.quantity) } : normalised);
      });
      return [...merged.values()];
    };
    const accountRequest = async (method, workspace) => {
      const response = await fetch('/apps/workspace', {
        method,
        credentials: 'same-origin',
        headers: method === 'PUT' ? { 'Content-Type': 'application/json' } : undefined,
        body: method === 'PUT' ? JSON.stringify({ workspace }) : undefined
      });
      if (!response.ok) throw new Error('Workspace request failed.');
      return response.json();
    };
    const showStatus = (message) => document.querySelectorAll('[data-ukfc-workspace-status]').forEach((element) => { element.textContent = message; });
    const storefrontList = (workspace) => {
      const lists = workspace.lists || [];
      return lists.find((list) => list.name === 'Storefront saved list')
        || lists.find((list) => list.name === 'Saved list')
        || makeList();
    };
    const saveToAccount = () => {
      if (!signedIn || !accountWorkspace) return;
      window.clearTimeout(pendingAccountSave);
      pendingAccountSave = window.setTimeout(async () => {
        try {
          const latest = (await accountRequest('GET')).workspace;
          const primary = (latest.lists || []).find((list) => list.name === 'Storefront saved list') || makeList();
          primary.name = 'Storefront saved list';
          primary.items = readList().map(normaliseItem);
          primary.updatedAt = new Date().toISOString();
          latest.lists = [primary, ...(latest.lists || []).filter((list) => list.id !== primary.id)];
          accountWorkspace = (await accountRequest('PUT', latest)).workspace;
          showStatus('Saved to your account.');
        } catch (error) {
          showStatus('List kept on this browser. Make another change when you are online to try saving again.');
        }
      }, 700);
    };
    const loadAccountWorkspace = async () => {
      if (!document.querySelector('[data-ukfc-customer-id]')?.dataset.ukfcCustomerId) return;
      try {
        const response = await accountRequest('GET');
        accountWorkspace = response.workspace;
        const primary = storefrontList(accountWorkspace);
        const items = changedBeforeAccountLoaded
          ? mergeItems(primary.items || [], readList())
          : primary.items || [];
        signedIn = true;
        writeList(browserItems(items));
        refresh();
        if (changedBeforeAccountLoaded) {
          showStatus('Saving the products you just added to your account…');
          saveToAccount();
        }
        changedBeforeAccountLoaded = false;
        reflectingAccountLoad = true;
        window.dispatchEvent(new CustomEvent('ukfc:quote-list-updated'));
        reflectingAccountLoad = false;
      } catch (error) {
        showStatus('Your account list could not be loaded. Products added now stay on this browser.');
      }
    };
    const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
    const cartUrl = (items) => `${window.location.origin}/cart/${items.map((item) => `${item.variantId}:${item.quantity}`).join(',')}`;
    const listText = (items) => ['UK Flow Centre saved list', '', ...items.map((item) => [
      `• ${item.quantity} × ${item.title}${item.variantTitle ? ` — ${item.variantTitle}` : ''}`,
      ...(item.sku ? [`  SKU: ${item.sku}`] : []),
      `  ${item.url}`
    ].join('\n')), '', ...(items.length && items.every((item) => !item.isPoa) ? [`Buy all items now: ${cartUrl(items)}`] : [])].join('\n');
    const refresh = () => {
      const items = readList();
      const quantity = items.reduce((total, item) => total + Number(item.quantity || 0), 0);
      document.querySelectorAll('[data-ukfc-workspace-count]').forEach((element) => { element.textContent = quantity; });
      const hasPoa = items.some((item) => item.isPoa);
      document.querySelectorAll('[data-ukfc-workspace-add-all]').forEach((button) => { button.disabled = !items.length || hasPoa; });
      document.querySelectorAll('[data-ukfc-workspace-quote-submit]').forEach((button) => {
        button.disabled = !items.length;
        button.title = items.length ? '' : 'Add a product to your List before requesting a quote.';
      });
      document.querySelectorAll('[data-ukfc-workspace-poa-warning]').forEach((element) => { element.hidden = !hasPoa; });
      document.querySelectorAll('[data-ukfc-workspace-items]').forEach((element) => {
        element.innerHTML = items.length ? `<ul class="ukfc-workspace-dialog__items" role="list">${items.map((item) => `<li><strong>${escapeHtml(item.quantity)} × ${escapeHtml(item.title)}${item.variantTitle ? ` — ${escapeHtml(item.variantTitle)}` : ''}</strong>${item.sku ? `<br><span>SKU: ${escapeHtml(item.sku)}</span>` : ''}<br><a href="${escapeHtml(item.url)}">View product</a><label class="ukfc-saved-item__quantity"><span>Quantity</span><input type="number" min="1" max="9999" step="1" inputmode="numeric" value="${escapeHtml(item.quantity)}" aria-label="Quantity for ${escapeHtml(item.title)}" data-ukfc-workspace-quantity data-variant-id="${escapeHtml(item.variantId)}"></label><button class="ukfc-saved-item__remove" type="button" data-ukfc-workspace-remove data-variant-id="${escapeHtml(item.variantId)}">Remove</button></li>`).join('')}</ul>` : '<p>Your saved list is empty. Add products from any product page.</p>';
      });
      document.querySelectorAll('[data-ukfc-workspace-quote-list]').forEach((field) => { field.value = listText(items); });
    };
    const copy = async (content) => { try { await navigator.clipboard.writeText(content); return true; } catch (error) { window.prompt('Copy this text', content); return false; } };
    const showPanel = (dialog, target) => {
      dialog.querySelectorAll('[data-ukfc-workspace-tab]').forEach((button) => {
        const active = button.dataset.ukfcWorkspaceTab === target;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active);
      });
      dialog.querySelectorAll('[data-ukfc-workspace-panel]').forEach((panel) => { panel.hidden = panel.dataset.ukfcWorkspacePanel !== target; });
    };
    const open = () => { const dialog = document.querySelector('[data-ukfc-workspace-dialog]'); if (dialog) { refresh(); dialog.showModal(); } };
    document.addEventListener('click', async (event) => {
      if (event.target.closest('[data-ukfc-open-workspace]')) { open(); return; }
      const dialog = event.target.closest('[data-ukfc-workspace-dialog]');
      if (!dialog) return;
      if (event.target.closest('[data-ukfc-close-workspace]')) { dialog.close(); return; }
      const tab = event.target.closest('[data-ukfc-workspace-tab]');
      if (tab) { showPanel(dialog, tab.dataset.ukfcWorkspaceTab); return; }
      const status = dialog.querySelector('[data-ukfc-workspace-status]');
      const items = readList();
      if (event.target.closest('[data-ukfc-workspace-email]')) { window.location.href = `mailto:?subject=${encodeURIComponent('UK Flow Centre saved list')}&body=${encodeURIComponent(listText(items))}`; return; }
      if (event.target.closest('[data-ukfc-workspace-whatsapp]')) { window.open(`https://wa.me/?text=${encodeURIComponent(listText(items))}`, '_blank', 'noopener'); return; }
      if (event.target.closest('[data-ukfc-workspace-copy]')) { await copy(listText(items)); if (status) status.textContent = 'List copied.'; return; }
      const remove = event.target.closest('[data-ukfc-workspace-remove]');
      if (remove) { writeList(items.filter((item) => String(item.variantId) !== String(remove.dataset.variantId))); refresh(); saveToAccount(); window.dispatchEvent(new CustomEvent('ukfc:quote-list-updated')); return; }
      const addAll = event.target.closest('[data-ukfc-workspace-add-all]');
      if (addAll) {
        if (!items.length) { if (status) status.textContent = 'Your saved list is empty.'; return; }
        if (items.some((item) => item.isPoa)) { if (status) status.textContent = 'Open Quotes to request a quote for this list, or remove price-on-application items before adding it to the basket.'; return; }
        addAll.disabled = true;
        try {
          const response = await fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items: items.map((item) => ({id: item.variantId, quantity: item.quantity}))}) });
          if (!response.ok) throw new Error('Some products could not be added to the basket.');
          window.location.assign('/cart');
        } catch (error) { if (status) status.textContent = error.message || 'We could not add this list to the basket.'; addAll.disabled = false; }
        return;
      }
      if (event.target.closest('[data-ukfc-workspace-clear]')) { writeList([]); refresh(); saveToAccount(); window.dispatchEvent(new CustomEvent('ukfc:quote-list-updated')); if (status) status.textContent = signedIn ? 'List cleared in this browser. Saving to your account…' : 'List cleared.'; }
    });
    document.addEventListener('submit', (event) => {
      if (event.target.id !== 'ukfc-workspace-quote-form' || readList().length) return;
      event.preventDefault();
      showStatus('Add a product to your List before requesting a quote.');
    });
    document.addEventListener('change', (event) => {
      const field = event.target.closest('[data-ukfc-workspace-quantity]');
      if (!field) return;
      const items = readList();
      const item = items.find((candidate) => String(candidate.variantId) === String(field.dataset.variantId));
      if (!item) { refresh(); return; }
      const quantity = Number(field.value);
      if (!Number.isInteger(quantity) || quantity < 1 || quantity > 9999) {
        field.value = item.quantity;
        showStatus('Enter a whole number from 1 to 9999.');
        return;
      }
      if (quantity === item.quantity) return;
      item.quantity = quantity;
      writeList(items);
      refresh();
      window.dispatchEvent(new CustomEvent('ukfc:quote-list-updated'));
      showStatus(signedIn ? 'Quantity changed. Saving to your account…' : 'Quantity changed on this browser.');
      saveToAccount();
    });
    window.addEventListener('ukfc:quote-list-updated', () => { if (reflectingAccountLoad) { refresh(); return; } if (!signedIn) changedBeforeAccountLoaded = true; refresh(); saveToAccount(); });
    window.addEventListener('ukfc:open-workspace-quotes', () => {
      open();
      const dialog = document.querySelector('[data-ukfc-workspace-dialog]');
      if (dialog) showPanel(dialog, 'quotes');
    });
    const initialise = () => {
      writeList(readList());
      refresh();
      const result = document.querySelector('[data-ukfc-quote-result]');
      if (result) {
        const dialog = result.closest('[data-ukfc-workspace-dialog]');
        if (dialog) {
          showPanel(dialog, 'quotes');
          dialog.showModal();
          result.focus();
        }
      }
      loadAccountWorkspace();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
    else initialise();
  }
  } catch(e) { console.error(e); }
})();

})();
